import { configureStore, } from "@reduxjs/toolkit";
import { reducer } from "./checkingReducer";

export const checkingStore = configureStore({ reducer });